var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQStudyActiveGift = function SvgQStudyActiveGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.171,
    height: 24.535,
    x: 4.914,
    y: 6.965,
    fill: "#F9725C",
    rx: 1.636
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEC3A8",
    d: "M15.547 6.965h4.907V31.5h-4.907zM9.822 2.79c0-.365.352-.627.702-.522l7.477 2.243 7.476-2.243a.545.545 0 0 1 .702.523v4.174H9.822z"
  })));
};
export { SvgQStudyActiveGift as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDM2IDM2IiBmaWxsPSJub25lIj4KICA8cmVjdCB4PSI0LjkxNDA2IiB5PSI2Ljk2NDc4IiB3aWR0aD0iMjYuMTcwOSIgaGVpZ2h0PSIyNC41MzUyIiByeD0iMS42MzU2OCIgZmlsbD0iI0Y5NzI1QyIvPgogIDxyZWN0IHg9IjE1LjU0NjkiIHk9IjYuOTY0NzgiIHdpZHRoPSI0LjkwNzA0IiBoZWlnaHQ9IjI0LjUzNTIiIGZpbGw9IiNGRUMzQTgiLz4KICA8cGF0aCBkPSJNOS44MjIyNyAyLjc5MDU0QzkuODIyMjcgMi40MjUzMSAxMC4xNzQzIDIuMTYzMzYgMTAuNTI0MiAyLjI2ODMxTDE4LjAwMDcgNC41MTEyNkwyNS40NzcyIDIuMjY4MzFDMjUuODI3IDIuMTYzMzYgMjYuMTc5MSAyLjQyNTMxIDI2LjE3OTEgMi43OTA1NFY2Ljk2NDc4SDkuODIyMjdWMi43OTA1NFoiIGZpbGw9IiNGRUMzQTgiLz4KPC9zdmc+Cg==";